import { useIsMenuActive } from "@/components/helpers";
import { Menu } from "@/models";
import classnames from "classnames";
import { FC, PropsWithChildren } from "react";

export const AsideMenuItemWithSub: FC<PropsWithChildren<{ menu: Menu }>> = ({ menu, children }) => {
  const isMenuActive = useIsMenuActive();

  const isActive = isMenuActive(menu);

  return (
    <div
      className={classnames("menu-item", { "here show": isActive }, "menu-accordion")}
      data-kt-menu-trigger="click"
    >
      <span className="menu-link">
        <span className="menu-icon">
          <span className={classnames("mdi", menu.icone?.trim() || "bullet bullet-dot")} />
        </span>
        <span className="menu-title">{menu.nome}</span>
        <span className="menu-arrow" />
      </span>
      <div className={classnames("menu-sub menu-sub-accordion", { "menu-active-bg": isActive })}>
        {children}
      </div>
    </div>
  );
};
